<app-help-page mainVideo="managing-dimensions"
               [tutorials]="['dimensions-in-adloop', 'normalized-dimensions']"
               [videos]="['managing-dimensions']"></app-help-page>
